import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { TabsPage } from '../pages/tabs/tabs';
import { ComingSoonPage } from '../pages/coming-soon/coming-soon';
import { PublicTabsPage } from '../pages/public-tabs/public-tabs';

import { TranslateService } from '@ngx-translate/core';

import { SmartAudioProvider } from '../providers/smart-audio/smart-audio';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = ComingSoonPage;

  constructor(private translate: TranslateService,
              platform: Platform,
              statusBar: StatusBar,
              splashScreen: SplashScreen,            
              public smartAudio: SmartAudioProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      
      smartAudio.preload('click', 'assets/audio/202313__7778__click-2.mp3');
      smartAudio.preload('error', 'assets/audio/error_01.mp3');      
      smartAudio.preload('clear', 'assets/audio/clear_piano.mp3');
    });
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('en');

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('en'); // Set your language here
    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      //this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts